import BerthingActivity from './berthing-activity.component'

export default BerthingActivity